// src/hooks/useInstagramFeed.ts
import { useEffect } from 'react';
import { useInstagramState } from '@/hooks/useInstagramState';
import { fetchInstagramPosts } from '@/utils/instagramApi';

export const useInstagramFeed = () => {
  const {
    posts,
    loading,
    error,
    lastUpdate,
    setLoading,
    updatePosts,
    setErrorMessage
  } = useInstagramState();

  const fetchPosts = async () => {
    try {
      setLoading(true);
      
      const data = await fetchInstagramPosts();
      updatePosts(data.posts, data.lastUpdate);
      
    } catch (err) {
      setErrorMessage(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Buscar posts na inicialização
    fetchPosts();
    
    // Atualizar automaticamente a cada 5 minutos
    const interval = setInterval(() => {
      console.log('🕒 Atualização automática programada');
      fetchPosts();
    }, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { 
    posts, 
    loading, 
    error, 
    lastUpdate, 
    refresh: fetchPosts 
  };
};